// extracted by mini-css-extract-plugin
module.exports = {"Auth":"Auth_Auth__1Zul_","AuthForm":"Auth_AuthForm__3wyhV"};